<div class="marketplace-catalog">
  <div class="toolbar">
    <input
      class="inp search"
      type="search"
      placeholder="Search name, SKU, barcode…"
      [(ngModel)]="searchTerm"
      (ngModelChange)="onSearch($event)" />
    <label class="chk">
      <input
        type="checkbox"
        [checked]="activeOnly"
        (change)="toggleActiveOnly($any($event.target).checked)" />
      <span>Active only</span>
    </label>
  </div>

  @if (errorMessage) {
    <div class="panel error-panel">{{ errorMessage }}</div>
  }

  @if (isLoading) {
    <div class="loading">Loading marketplace catalog…</div>
  } @else {
    <div class="muted">Showing {{ rangeLabel }} product(s)</div>

    <div class="tbl-wrap">
      <table class="tbl">
        <thead>
          <tr>
            <th>Product</th>
            <th>Business</th>
            <th>Category</th>
            <th class="num">Price</th>
            <th>SKU</th>
            <th>Status</th>
            <th>Updated</th>
          </tr>
        </thead>
        <tbody>
          @for (item of items; track item.itemId) {
            <tr>
              <td>{{ item.itemName }}</td>
              <td>{{ item.businessName || item.businessId }}</td>
              <td>{{ item.categoryName || '—' }}</td>
              <td class="num">{{ item.price | number: '1.2-2' }}</td>
              <td>{{ item.sku || '—' }}</td>
              <td>
                <span class="pill" [class.pill-amber]="!item.isActive">{{ item.isActive ? 'Active' : 'Inactive' }}</span>
              </td>
              <td>{{ item.updatedAt | date: 'short' }}</td>
            </tr>
          }
          @if (!items.length) {
            <tr><td colspan="7" class="empty">No marketplace products found.</td></tr>
          }
        </tbody>
      </table>
    </div>

    @if (totalPages > 1) {
      <div class="pagination">
        <button
          type="button"
          class="act-ghost act-sm"
          [disabled]="page === 1"
          (click)="setPage(page - 1)">
          ← Prev
        </button>
        <span class="page-info">Page {{ page }} of {{ totalPages }}</span>
        <button
          type="button"
          class="act-ghost act-sm"
          [disabled]="page === totalPages"
          (click)="setPage(page + 1)">
          Next →
        </button>
      </div>
    }
  }
</div>
